<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h2>{{ $t('users.users') }}</h2>
        <users-table-component/>
    </layout-authenticated>
</template>

<script>
import UsersTableComponent from "@/components/admin/tables/UsersTableComponent";
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: 'Users',
    components: {LayoutAuthenticated, UsersTableComponent},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.administration'),
                    href: '/admin'
                },
                {
                    text: this.$t('users.users'),
                    href: '/admin/users',
                    disabled: true
                }
            ];
        }
    }
}
</script>
